module.exports = __webpack_public_path__ + "static/media/csr_education.dcfa330c.JPG";